import { createFileRoute } from "@tanstack/react-router";
import { OverviewHeader } from "../components/EnterpriseOverviewLanding";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { enterpriseOverviewQueryOptions } from "../queries/useGetEnterpriseOverview";
import { healthScoreQueryOptions } from "../queries/useGetHealthScore";
import { EnterpriseOverviewPage } from "../screens/EnterpriseOverviewPage";

export const Route = createFileRoute("/_app/")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }

    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );

    void context.queryClient.prefetchQuery(
      healthScoreQueryOptions(customer.customerId),
    );

    await context.queryClient.ensureQueryData(
      enterpriseOverviewQueryOptions(customer.customerId),
    );
  },
  staticData: { pageHeader: OverviewHeader },
  component: () => <EnterpriseOverviewPage />,
});
